<template>
  <div class="pp-content">
    <div class="pp-header pp-header--simple pp-header--image-generic">
      <div class="pp-header__title">
        Logging in...
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '../API.js';

export default {
  name: 'auth-shopify',
  data() {
    return {}
  },
  mounted() {
    console.log(this.$route.query);
    var id = this.$route.query.id;
    var token = this.$route.query.token;

    if (!id || !token) {
      window.location = ' https://www.pristineclassical.com/pages/player-auth';
    }

    api.authenticate(id, token, 'shopify', (success) => {
      if (success) {
        this.$router.push('/');
      } else {
        setTimeout(() => {
          window.location = ' https://www.pristineclassical.com/pages/player-auth';
        }, 2000)
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// AuthShopify.vue?9fab08e6